import {DBConfig} from 'ngx-indexed-db';

export class IndexedDbModel {

  public static NOME_DB = 'RoteirizadorDb';
  public static  DB_ROTEIRIZAZAO_FILTROS = 'roteirizacao_filtros';
  public static DB_ROTEIRIZAZAO_LISTA_ENTREGAS = 'roteirizacao_lista_entregas';
  public static DB_ROTEIRIZAZAO_LISTA_PRECARGAS = 'roteirizacao_listaPreCargas';
  public static DB_ROTEIRIZACAO_ORDEM_GRID_PRECARGAS = 'roteirizacao_ordemGridPreCarga';
  public static DB_FILTROS_DISTRIBUICAO_AUTOMATICA = 'filtros_distribuicaoAutomatica';
  public static  DB_CORES_ROTAS = 'cores_rotas';

  public static DB_CONFIG: DBConfig = {
    name: IndexedDbModel.NOME_DB,
    version: 1,
    objectStoresMeta: [{
      store: IndexedDbModel.DB_ROTEIRIZAZAO_FILTROS,
      storeConfig: {keyPath: 'id', autoIncrement: true},
      storeSchema: []
    }, {
      store: IndexedDbModel.DB_ROTEIRIZAZAO_LISTA_ENTREGAS,
      storeConfig: {keyPath: 'id', autoIncrement: true},
      storeSchema: []
    }, {
      store: IndexedDbModel.DB_ROTEIRIZAZAO_LISTA_PRECARGAS,
      storeConfig: {keyPath: 'id', autoIncrement: true},
      storeSchema: []
    },
    {
      store: IndexedDbModel.DB_ROTEIRIZACAO_ORDEM_GRID_PRECARGAS,
      storeConfig: {keyPath: 'id', autoIncrement: true},
      storeSchema: []
    }, {
      store: IndexedDbModel.DB_FILTROS_DISTRIBUICAO_AUTOMATICA,
      storeConfig: {keyPath: 'id', autoIncrement: true},
      storeSchema: [],
    }, {
        store: IndexedDbModel.DB_CORES_ROTAS,
        storeConfig: {keyPath: 'id', autoIncrement: true},
        storeSchema: [],
      }
  ]
  };
}
